var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import View from "@core/views";
import Toast from "@core/components/Toast";
var UserDetailView = /** @class */ (function (_super) {
    __extends(UserDetailView, _super);
    function UserDetailView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserDetailView.prototype.onMounted = function () {
        var superUserElement = document.getElementById('id_is_superuser');
        var excelAllowedElement = document.getElementById('id_excel_allowed');
        var isActiveElement = document.getElementById('id_is_active');
        var isAccountDeletedElement = document.getElementById('deleted-account');
        var isExternal = document.getElementById('id_is_external').checked;
        var isAdmin = document.getElementById('id_groups_0').checked;
        var isSalesPerson = document.getElementById('id_groups_1').checked;
        var isProduction = document.getElementById('id_groups_2').checked;
        var isAIElem = document.getElementById('id_groups_3');
        var isAI = false;
        if (isAIElem) {
            isAI = isAIElem.checked;
        }
        document.getElementById('id_groups_0').disabled = isExternal;
        document.getElementById('id_groups_1').disabled = isExternal;
        document.getElementById('id_groups_2').disabled = !isExternal;
        if (!isAdmin && !isSalesPerson && !isProduction && !isAI) {
            superUserElement.checked = false;
            excelAllowedElement.checked = false;
        }
        if (isAccountDeletedElement.value == 'True') {
            isActiveElement.disabled = true;
        }
        excelAllowedElement.disabled = !isAdmin && !isSalesPerson && !isProduction && !isAI;
        if (superUserElement != null) {
            superUserElement.disabled = isExternal || (!isAdmin && !isSalesPerson);
        }
    };
    /**
     * externalSelectionChanged
     * @param inputElement
     */
    UserDetailView.prototype.externalSelectionChanged = function (inputElement) {
        var checked = inputElement.checked;
        var superUserElement = document.getElementById('id_is_superuser');
        document.getElementById('id_groups_0').checked = false;
        document.getElementById('id_groups_1').checked = false;
        document.getElementById('id_groups_2').checked = false;
        document.getElementById('id_groups_0').disabled = checked;
        document.getElementById('id_groups_1').disabled = checked;
        document.getElementById('id_groups_2').disabled = !checked;
        document.getElementById('id_excel_allowed').checked = false;
        if (superUserElement != null) {
            superUserElement.checked = false;
        }
        document.getElementById('id_excel_allowed').disabled = true;
        if (superUserElement != null) {
            superUserElement.disabled = true;
        }
        var groupTable = document.getElementById('customer_groups_table');
        groupTable.querySelectorAll("input[type='radio']").forEach(function (element) {
            element.checked = element.value == '';
            element.disabled = checked;
        });
        groupTable.querySelectorAll("input[type='checkbox']").forEach(function (element) {
            element.disabled = checked;
        });
    };
    UserDetailView.prototype.superUserValueChanged = function (inputElement) {
        // const superuser = (<HTMLInputElement>document.getElementById('id_is_superuser'));
        // if (inputElement === superuser) {
        //     if (inputElement.checked) {
        //         (<HTMLInputElement>document.getElementById('id_db_default_customer')).value = 'none';
        //         (<HTMLInputElement>document.getElementById('id_db_default_customer')).focus();
        //     }
        // }
    };
    /**
     * inputFieldValueChanged
     * @param inputElement
     */
    UserDetailView.prototype.inputFieldValueChanged = function (inputElement) {
        var admin = document.getElementById('id_groups_0');
        var sales = document.getElementById('id_groups_1');
        var production = document.getElementById('id_groups_2');
        var ai = document.getElementById('id_groups_3');
        if (inputElement == ai) {
            return;
        }
        document.getElementById('id_excel_allowed').checked = false;
        document.getElementById('id_is_superuser').checked = false;
        if (inputElement === admin) {
            document.getElementById('id_excel_allowed').disabled = !inputElement.checked;
            document.getElementById('id_is_superuser').disabled = !inputElement.checked;
        }
        else if (inputElement === sales) {
            document.getElementById('id_excel_allowed').disabled = !inputElement.checked;
            document.getElementById('id_is_superuser').disabled = !inputElement.checked;
        }
        else if (inputElement === production) {
            document.getElementById('id_excel_allowed').disabled = !inputElement.checked;
            document.getElementById('id_is_superuser').disabled = true;
        }
    };
    /**
     * organizationSelectionChanged
     * @param HTMLInputElement
     */
    UserDetailView.prototype.organizationSelectionChanged = function (inputElement) {
        var groupTable = document.getElementById('customer_groups_table');
        groupTable.querySelectorAll("input[type='radio']").forEach(function (element) {
            element.checked = element.value == '';
            element.disabled = true;
        });
        groupTable.querySelectorAll("input[type='checkbox']").forEach(function (element) {
            element.disabled = true;
        });
    };
    /**
     * OnClick-listener for "Select all"-button
     * @param checkboxElement
     */
    UserDetailView.prototype.onToggleAllClick = function (checkboxElement) {
        var groupId = checkboxElement.getAttribute('data-group_pk'), checkedValue = checkboxElement.checked, groupTable = document.getElementById('customer_groups_table');
        groupTable.querySelectorAll("input[type='checkbox']").forEach(function (element) {
            if (element != checkboxElement) {
                element.checked = false;
            }
        });
        document.body.querySelectorAll("input[type='radio']").forEach(function (element) {
            if (!element.parentElement.parentElement.hidden) {
                if (element.value == groupId) {
                    element.checked = checkedValue;
                }
                if (checkedValue == false && element.value == '') {
                    element.checked = true;
                }
            }
        });
    };
    /**
     * OnClick-listener for "Remove user"-button
     * @param buttonElement
     */
    UserDetailView.prototype.onRemoveUserClick = function (buttonElement) {
        var userId = buttonElement.getAttribute('data-user_pk');
        var restore = buttonElement.getAttribute('data-restore');
        var data = { user_id: userId, restore: restore };
        this.app.api.private('toggle_user_removal', {
            data: data
        }).then(function (response) {
            document.location.reload();
            if (response.was_restored == true) {
                Toast.success(django.gettext('User was restored successfully'));
            }
            else {
                Toast.success(django.gettext('User was deleted successfully'));
            }
        }, function (error) {
            if (error.serverError) {
                Toast.error(error.serverError.error);
            }
            else {
                Toast.error(django.gettext('Unable to update user removal status, please try again'));
            }
        });
    };
    return UserDetailView;
}(View));
export default UserDetailView;
